import CollapsibleFilters from "../collapsible-filters/collapsible-filters";


export default class CollapsibleNewsFilters extends CollapsibleFilters {

}
